import { render, staticRenderFns } from "./BillingLayout.vue?vue&type=template&id=020d336c&scoped=true"
import script from "./BillingLayout.vue?vue&type=script&lang=js"
export * from "./BillingLayout.vue?vue&type=script&lang=js"
import style0 from "./BillingLayout.vue?vue&type=style&index=0&id=020d336c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020d336c",
  null
  
)

export default component.exports